interface StatMiniCardProps {
  icon: string;
  label: string;
  value: string | number;
  unit: string;
}

export function StatMiniCard({ icon, label, value, unit }: StatMiniCardProps) {
  return (
    <div className="bg-white/5 border border-white/5 rounded-4xl p-4 flex flex-col gap-1">
      <div className="flex items-center gap-1.5 text-white/50 text-xs font-medium uppercase tracking-wider">
        <span className="material-symbols-outlined text-base">
          {icon}
        </span>
        {label}
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-2xl font-bold text-white">
          {value}
        </span>
        <span className="text-sm font-medium text-white/50">
          {unit}
        </span>
      </div>
    </div>
  );
}
